export default __webpack_public_path__ + "static/media/bannersweb_promo_amazon_azul_330x330.d433a506.png";